/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBrokerPayloadDto
 */
export interface CreateBrokerPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    status: CreateBrokerPayloadDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    type?: CreateBrokerPayloadDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    group?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    brokerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    legalEntityName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    claimsEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    financeEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    website?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrokerPayloadDto
     */
    hasToba: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateBrokerPayloadDto
     */
    tobaCompletionDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBrokerPayloadDto
     */
    hasKyc: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateBrokerPayloadDto
     */
    kycCompletionDate?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBrokerPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateBrokerPayloadDto
     */
    state?: string;
}


/**
 * @export
 */
export const CreateBrokerPayloadDtoStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type CreateBrokerPayloadDtoStatusEnum = typeof CreateBrokerPayloadDtoStatusEnum[keyof typeof CreateBrokerPayloadDtoStatusEnum];

/**
 * @export
 */
export const CreateBrokerPayloadDtoTypeEnum = {
    Wholesale: 'Wholesale',
    Retail: 'Retail'
} as const;
export type CreateBrokerPayloadDtoTypeEnum = typeof CreateBrokerPayloadDtoTypeEnum[keyof typeof CreateBrokerPayloadDtoTypeEnum];


/**
 * Check if a given object implements the CreateBrokerPayloadDto interface.
 */
export function instanceOfCreateBrokerPayloadDto(value: object): value is CreateBrokerPayloadDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('legalEntityName' in value) || value['legalEntityName'] === undefined) return false;
    if (!('hasToba' in value) || value['hasToba'] === undefined) return false;
    if (!('hasKyc' in value) || value['hasKyc'] === undefined) return false;
    return true;
}

export function CreateBrokerPayloadDtoFromJSON(json: any): CreateBrokerPayloadDto {
    return CreateBrokerPayloadDtoFromJSONTyped(json, false);
}

export function CreateBrokerPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBrokerPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'type': json['type'] == null ? undefined : json['type'],
        'group': json['group'] == null ? undefined : json['group'],
        'name': json['name'],
        'brokerEmail': json['brokerEmail'] == null ? undefined : json['brokerEmail'],
        'legalEntityName': json['legalEntityName'],
        'claimsEmail': json['claimsEmail'] == null ? undefined : json['claimsEmail'],
        'financeEmail': json['financeEmail'] == null ? undefined : json['financeEmail'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'address': json['address'] == null ? undefined : json['address'],
        'postcode': json['postcode'] == null ? undefined : json['postcode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'website': json['website'] == null ? undefined : json['website'],
        'hasToba': json['hasToba'],
        'tobaCompletionDate': json['tobaCompletionDate'] == null ? undefined : (new Date(json['tobaCompletionDate'])),
        'hasKyc': json['hasKyc'],
        'kycCompletionDate': json['kycCompletionDate'] == null ? undefined : (new Date(json['kycCompletionDate'])),
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function CreateBrokerPayloadDtoToJSON(json: any): CreateBrokerPayloadDto {
    return CreateBrokerPayloadDtoToJSONTyped(json, false);
}

export function CreateBrokerPayloadDtoToJSONTyped(value?: CreateBrokerPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'type': value['type'],
        'group': value['group'],
        'name': value['name'],
        'brokerEmail': value['brokerEmail'],
        'legalEntityName': value['legalEntityName'],
        'claimsEmail': value['claimsEmail'],
        'financeEmail': value['financeEmail'],
        'phoneNumber': value['phoneNumber'],
        'address': value['address'],
        'postcode': value['postcode'],
        'city': value['city'],
        'country': value['country'],
        'website': value['website'],
        'hasToba': value['hasToba'],
        'tobaCompletionDate': value['tobaCompletionDate'] == null ? undefined : ((value['tobaCompletionDate']).toISOString()),
        'hasKyc': value['hasKyc'],
        'kycCompletionDate': value['kycCompletionDate'] == null ? undefined : ((value['kycCompletionDate']).toISOString()),
        'fileIds': value['fileIds'],
        'state': value['state'],
    };
}

